import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { ApesterBlockAttsInterface } from '~/types/AppData/Blocks/ApesterBlockInterface';
import { Logger } from '~/utilities/logger';

export default component$((value: ApesterBlockAttsInterface): JSX.Element => {
  new Logger().error('ApsterBlock not configured: ' + value);

  return <></>;
});
